import { atom } from 'jotai'
import type {
    LaterAvailabilityTime,
    SearchSubmissionType,
} from './types'
import { getSearchParams } from './helpers'
// @ts-ignore
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js'

const {
    paramLocation,
    paramBeginsAtDate,
    paramBeginsAtTime,
    paramEndsAtDate,
    paramEndsAtTime,
} = getSearchParams()

const searchSubmissionValueAtom = atom<SearchSubmissionType>({
    startDate: moment(paramBeginsAtDate, ['DD.MM.YYYY', 'YYYY-MM-DD']),
    startTime: paramBeginsAtTime,
    endDate: moment(paramEndsAtDate, ['DD.MM.YYYY', 'YYYY-MM-DD']),
    endTime: paramEndsAtTime,
    location: paramLocation,
})

export type SuggestedStartTimeShift = {
    id: number,
    previousSearch: SearchSubmissionType,
    appliedSearch: SearchSubmissionType,
    startTime: LaterAvailabilityTime,
    urlVariant?: 'map' | 'reservation',
    garageId?: string,
}

export const suggestedStartTimeShiftAtom = atom<SuggestedStartTimeShift | null>(null)

export const searchSubmissionAtom = atom(
    get => get(searchSubmissionValueAtom),
    (_get, set, searchSubmission: SearchSubmissionType) => {
        set(searchSubmissionValueAtom, searchSubmission)
        set(suggestedStartTimeShiftAtom, null)
    },
)
